import React from 'react';
import { Search, X } from 'lucide-react';

const STONE  = '#8C8275';
const PAPER  = '#FDFBF8';
const FONT_SANS = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export default function SearchBar({ value, onChange }) {
  return (
    <div style={{
      padding: '12px 16px',
      background: PAPER,
      borderRadius: '12px',
      border: '1px solid rgba(139,69,19,0.12)',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    }}>
      <Search size={16} strokeWidth={2} color={STONE} />

      <input
        type="text"
        name="twp-jobs-search"
        autoComplete="off"
        placeholder="Search customer, contract #, job name, notes, address..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          flex: 1,
          border: 'none',
          outline: 'none',
          fontSize: '14px',
          fontFamily: FONT_SANS,
          background: 'transparent'
        }}
      />

      {value && (
        <button
          onClick={() => onChange('')}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            color: STONE
          }}
        >
          <X size={16} strokeWidth={2} />
        </button>
      )}
    </div>
  );
}
